module.exports = __webpack_public_path__ + "static/media/icon4.09a51552.png";


//////////////////
// WEBPACK FOOTER
// ./public/assets/newpage/icon4.png
// module id = 218
// module chunks = 0